import { c as _c } from "react/compiler-runtime";
import type { DefinitionListItem } from '@newfront-insurance/core-ui';
import { DefinitionList } from '@newfront-insurance/core-ui';
import { CalendarDate, DateFormatStyle } from '@newfront-insurance/string-formatters';
import compact from 'lodash/compact';
import type { JSX } from 'react';
import type { Policy } from '../../bff/types';
import { stringifyLinesOfCoverage } from '../../utils/stringifyLinesOfCoverage';
interface Props {
  policy: Policy;
  accountHref?: string;
  onAccountClick?: () => void;
  hideTitle?: boolean;
}
export function PolicyDefinitionList(props) {
  const $ = _c(7);
  const {
    policy,
    hideTitle,
    onAccountClick,
    accountHref
  } = props;
  let t0;
  if ($[0] !== accountHref || $[1] !== onAccountClick || $[2] !== policy) {
    t0 = createPolicyDefinitionList({
      policy,
      onAccountClick,
      accountHref
    });
    $[0] = accountHref;
    $[1] = onAccountClick;
    $[2] = policy;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== hideTitle || $[5] !== t0) {
    t1 = <DefinitionList hideTitle={hideTitle} items={t0} labelWidth="150px" />;
    $[4] = hideTitle;
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}
export function createPolicyDefinitionList(props: Props): DefinitionListItem[] {
  const {
    policy,
    accountHref,
    onAccountClick
  } = props;
  const {
    account,
    expirationDate,
    linesOfCoverage,
    effectiveDate,
    cancellationEffectiveDate,
    policyNumber,
    carrier
  } = policy;
  let items: DefinitionListItem[] = [];
  if (account) {
    items.push({
      type: 'name',
      title: 'Client',
      value: account?.name || '-',
      href: accountHref,
      onClick: onAccountClick
    });
  }
  items = compact([...items, linesOfCoverage && {
    type: 'document',
    title: 'Line of coverage',
    value: linesOfCoverage.length > 0 ? stringifyLinesOfCoverage(linesOfCoverage) : '-'
  }, {
    type: 'dateRange',
    title: 'Effective dates',
    value: `${CalendarDate.fromDate(effectiveDate, 'UTC').format({
      style: DateFormatStyle.STANDARD
    })} - ${CalendarDate.fromDate(cancellationEffectiveDate ?? expirationDate, 'UTC').format({
      style: DateFormatStyle.STANDARD
    })}`
  }, cancellationEffectiveDate && {
    type: 'dateRange',
    title: 'Prev. exp. date',
    value: `${CalendarDate.fromDate(expirationDate, 'UTC').format({
      style: DateFormatStyle.STANDARD
    })}`
  }, {
    type: 'business',
    title: 'Carrier',
    value: carrier?.name || '-'
  }]);
  if (policyNumber) {
    items.push({
      type: 'number',
      title: 'Policy number',
      value: policyNumber,
      target: '_blank'
    });
  }
  return items;
}